import { Capacitor } from "@capacitor/core";
import * as SentryCapacitor from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";
import { getVisitorId } from "./services/utils";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  // TODO : Change MODE to VITE_ENV maybe?
  const baseEnv = import.meta.env.MODE; // e.g. "prod", "dev"
  const platform = Capacitor.isNativePlatform() ? "mobile" : "web";
  const environment = `${platform}-${baseEnv}`;

  // Sentry Capacitor should be initialized with the React SDK's init function.
  // This setup works for both Web (PWA) and Native (Capacitor).
  SentryCapacitor.init(
    {
      dsn,
      environment,
      release: import.meta.env.VITE_APP_VERSION,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      integrations: [
        SentryReact.replayIntegration({
          maskAllText: false,
        }),
      ],
      // Session Replay (Web only)
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: baseEnv === "prod" ? 1.0 : 0.1,
      tracesSampleRate: 0.1,
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/cyno\.dog/],
    },
    SentryReact.init
  );

  console.log(`Sentry initialized (${environment})`);

  SentryReact.setUser({
    id: getVisitorId(),
  });
}
